import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withModifiers as _withModifiers, Teleport as _Teleport, Transition as _Transition, withCtx as _withCtx, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "mb-4 border-b border-black-200 pb-24" }
const _hoisted_2 = {
  key: 0,
  class: "mt-16"
}
const _hoisted_3 = {
  key: 0,
  class: "block pb-12 text-20 font-medium text-black-900"
}
const _hoisted_4 = { class: "flex justify-between gap-8 laptop:gap-16" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "center-x absolute -bottom-16 min-w-[60%] whitespace-nowrap rounded border border-black-300 bg-black-200 p-8 text-12 leading-none text-black-700 laptop:-bottom-18 laptop:min-w-[70%] laptop:py-4 laptop:text-14"
}
const _hoisted_7 = { class: "mt-32 flex items-center gap-x-12 uppercase" }
const _hoisted_8 = {
  key: 0,
  class: "text-16 text-black-400"
}
const _hoisted_9 = { class: "text-26 font-medium text-black-900" }
const _hoisted_10 = {
  key: 1,
  class: "badge-small badge-pill badge-primary font-medium uppercase"
}
const _hoisted_11 = { class: "py-24 text-black-900" }
const _hoisted_12 = {
  key: 0,
  class: "block pb-12 text-20 font-medium"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "pointer-events-none relative h-full w-full" }
const _hoisted_15 = {
  key: 0,
  class: "block pt-8 text-12 font-medium tablet:text-14"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 1,
  class: "pointer-events-none w-full"
}
const _hoisted_18 = { class: "relative aspect-kit w-full border border-dashed bg-black-100 transition-shadow duration-200 group-hover:shadow-lg" }
const _hoisted_19 = { class: "center-center absolute rounded-full bg-white p-14" }
const _hoisted_20 = { class: "block pt-8 text-12 font-normal tablet:text-14" }
const _hoisted_21 = {
  key: 0,
  class: "pt-24"
}
const _hoisted_22 = {
  key: 0,
  class: "flex items-center gap-x-8 pb-12 text-20 font-medium tablet:flex-col tablet:items-start laptop:flex-row laptop:items-center"
}
const _hoisted_23 = { key: 0 }
const _hoisted_24 = {
  key: 1,
  class: "badge-small badge-pill badge-secondary"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "aspect-kit w-full bg-black-100" }
const _hoisted_27 = { class: "p-4" }
const _hoisted_28 = { class: "flex flex-wrap items-center justify-center gap-x-8" }
const _hoisted_29 = {
  key: 0,
  class: "text-12 text-black-400"
}
const _hoisted_30 = { class: "text-14 font-medium text-black-900" }
const _hoisted_31 = { class: "flex items-center justify-evenly gap-x-4 pt-4" }
const _hoisted_32 = { class: "block text-center text-12 font-normal !leading-snug tablet:text-14" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = {
  key: 0,
  class: "tablet:h5 mb-16"
}
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = ["disabled"]
const _hoisted_37 = {
  key: 0,
  class: "fixed bottom-0 left-0 right-0 z-[99] p-16 tablet:hidden"
}
const _hoisted_38 = ["disabled"]
const _hoisted_39 = ["value"]
const _hoisted_40 = ["value"]
const _hoisted_41 = ["value"]
const _hoisted_42 = ["value"]
const _hoisted_43 = ["value"]
const _hoisted_44 = ["value"]
const _hoisted_45 = ["value"]
const _hoisted_46 = ["value"]
const _hoisted_47 = ["name", "value"]
const _hoisted_48 = ["value"]
const _hoisted_49 = { class: "mt-8 flex items-center gap-x-4 text-12" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_skeleton = _resolveComponent("v-skeleton")
  const _component_v_image = _resolveComponent("v-image")
  const _component_v_icon = _resolveComponent("v-icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.product?.variants.length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          ($props.setHeadline)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString($props.setHeadline), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.product.variants, (variant, index) => {
              return (_openBlock(), _createElementBlock("button", {
                key: variant.id,
                type: "button",
                class: _normalizeClass(["btn-xsmall laptop:btn-medium btn-rounded relative w-full border border-black-900 !py-16 hover:bg-black-200 hover:text-black-900", 
            index === $data.variantIndex
              ? 'btn-primary pointer-events-none hover:bg-black-900 hover:text-white'
              : 'btn-secondary'
          ]),
                onClick: $event => ($options.selectVariant(index))
              }, [
                (variant.badge_label)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(variant.badge_label), 1))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(variant.title), 1)
              ], 10, _hoisted_5))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      ($options.discountPercentage)
        ? (_openBlock(), _createElementBlock("del", _hoisted_8, _toDisplayString($options.formattedCompareAtPrice), 1))
        : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_9, [
        _createElementVNode("span", null, _toDisplayString($options.formattedPrice), 1)
      ]),
      ($options.discountPercentage)
        ? (_openBlock(), _createElementBlock("span", _hoisted_10, " -" + _toDisplayString($options.discountPercentage) + "% ", 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", null, [
        ($props.designHeadline)
          ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString($props.designHeadline), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["grid auto-rows-max grid-cols-3 gap-x-8 gap-y-16 tablet:grid-cols-2 laptop:grid-cols-3", $options.kitItemsQuantity >= 4 && 'desktop:grid-cols-4'])
        }, [
          ($data.isPrefillingKit)
            ? (_openBlock(), _createBlock(_component_v_skeleton, {
                key: 0,
                rep: $options.kitItemsQuantity,
                class: "aspect-kit h-full w-full"
              }, null, 8, ["rep"]))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($options.kitItemsQuantity, (item, i) => {
                return (_openBlock(), _createElementBlock("button", {
                  id: "modal-trigger",
                  key: item,
                  ref_for: true,
                  ref: "itemPicker",
                  type: "button",
                  class: "group relative flex",
                  "data-modal-id": "product-picker",
                  onClick: _withModifiers($event => ($options.openDrawer($event, i)), ["self"])
                }, [
                  ($data.products[i])
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_v_image, {
                            width: 350,
                            source: $data.products[i].featured_image,
                            class: "aspect-kit w-full object-cover object-center"
                          }, null, 8, ["source"]),
                          ($data.products[i].title)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString($data.products[i].title), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "absolute right-4 top-4 rounded border border-black-200 bg-white p-6 hover:shadow",
                          onClick: $event => ($options.removeItem(i))
                        }, [
                          _createVNode(_component_v_icon, {
                            icon: "close",
                            width: 11,
                            height: 11,
                            color: "#121212"
                          })
                        ], 8, _hoisted_16)
                      ], 64))
                    : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _createVNode(_component_v_icon, {
                              icon: "plus",
                              width: 13,
                              height: 13,
                              color: "#121212"
                            })
                          ])
                        ]),
                        _createElementVNode("span", _hoisted_20, _toDisplayString($data.locale.design) + " " + _toDisplayString(i + 1), 1)
                      ]))
                ], 8, _hoisted_13))
              }), 128))
        ], 2)
      ]),
      ($props.accessories?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            ($props.accessoriesHeadline || $options.accessoriesDiscountPercentage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  ($props.accessoriesHeadline)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString($props.accessoriesHeadline), 1))
                    : _createCommentVNode("", true),
                  ($options.accessoriesDiscountPercentage)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_24, " -" + _toDisplayString($options.accessoriesDiscountPercentage) + "% ", 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["grid auto-rows-max grid-cols-3 gap-x-8 gap-y-16 tablet:grid-cols-2 laptop:grid-cols-3", {
            'mobile-xl:grid-cols-4 desktop:grid-cols-4':
              $props.accessories.length >= 4 || $options.kitItemsQuantity >= 4,
          }])
            }, [
              ($data.isPrefillingKit)
                ? (_openBlock(), _createBlock(_component_v_skeleton, {
                    key: 0,
                    rep: 4,
                    class: "aspect-kit h-full w-full"
                  }))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($props.accessories.filter((accessory) => accessory.available), (accessory, index) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: accessory.id,
                      type: "button",
                      class: _normalizeClass(["relative flex flex-col items-center overflow-hidden rounded border-[1.5px] border-black-200 p-4 laptop:hover:border-black-300", {'!border-black-900 shadow': $options.selectedAccessoriesID.includes(accessory.id)}]),
                      onClick: $event => ($options.toggleAccessory($event, accessory))
                    }, [
                      _createElementVNode("div", _hoisted_26, [
                        (accessory.featured_image)
                          ? (_openBlock(), _createBlock(_component_v_image, {
                              key: 0,
                              lazyloaded: "",
                              source: accessory.featured_image,
                              "source-mobile": accessory.featured_image,
                              class: "pointer-events-none h-full w-full object-cover object-center"
                            }, null, 8, ["source", "source-mobile"]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          ($options.accessoriesDiscountPercentage)
                            ? (_openBlock(), _createElementBlock("del", _hoisted_29, _toDisplayString($options.formatPrice(accessory.price)), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", _hoisted_30, _toDisplayString($options.formatPrice(accessory.price * (1 - $options.accessoriesDiscountPercentage / 100))), 1)
                        ]),
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("span", _hoisted_32, _toDisplayString(accessory.title), 1)
                        ])
                      ]),
                      ($props.isAccessoriesTooltipEnabled && accessory.description)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            id: "modal-trigger",
                            class: "absolute top-8 right-8 hover:scale-105",
                            type: "button",
                            "data-modal-id": "accessory-tooltip",
                            onClick: _withModifiers($event => ($options.showAccessoryTooltip($event, index)), ["self","stop"])
                          }, [
                            _createVNode(_component_v_icon, {
                              class: "rounded-full border border-white bg-black-900 p-[1px]",
                              icon: "question",
                              width: 22,
                              height: 22,
                              color: "#fff"
                            })
                          ], 8, _hoisted_33))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_25))
                  }), 128)),
              ($props.isAccessoriesTooltipEnabled && $props.accessories?.[$data.accessoryIndex]?.description)
                ? (_openBlock(), _createBlock(_Teleport, {
                    key: 2,
                    to: "#accessory-tooltip-content"
                  }, [
                    ($props.accessories?.[$data.accessoryIndex]?.title)
                      ? (_openBlock(), _createElementBlock("h6", _hoisted_34, _toDisplayString($props.accessories[$data.accessoryIndex].title), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      innerHTML: $options.sanitizeHTML($props.accessories[$data.accessoryIndex].description)
                    }, null, 8, _hoisted_35),
                    _createElementVNode("button", {
                      type: "button",
                      class: "absolute top-24 right-16 tablet:top-32 tablet:right-32",
                      "data-modal-id": "accessory-tooltip",
                      onClick: _cache[0] || (_cache[0] = (...args) => ($options.hideAccessoryTooltip && $options.hideAccessoryTooltip(...args)))
                    }, [
                      _createVNode(_component_v_icon, {
                        icon: "close",
                        width: 17,
                        height: 17,
                        "width-mobile": 14,
                        "height-mobile": 14
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 2)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("form", {
      ref: "addToCartForm",
      name: "add_to_cart",
      onSubmit: _cache[1] || (_cache[1] = _withModifiers((...args) => ($options.addToCart && $options.addToCart(...args)), ["prevent"]))
    }, [
      _createElementVNode("button", {
        type: "submit",
        name: "add",
        class: "btn btn-primary btn-pill w-full py-8 text-18 capitalize",
        disabled: $data.isPrefillingKit
      }, _toDisplayString($options.addToCartText), 9, _hoisted_36),
      ($props.stickyEnabled)
        ? (_openBlock(), _createBlock(_Transition, {
            key: 0,
            name: "fade"
          }, {
            default: _withCtx(() => [
              ($data.isButtonSticky)
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    _createElementVNode("button", {
                      name: "add",
                      class: "btn btn-primary btn-pill w-full py-8 text-18 capitalize",
                      disabled: $data.isPrefillingKit
                    }, _toDisplayString($options.addToCartText), 9, _hoisted_38)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([$options.currentVariant, ...$options.kitItems], (item, index) => {
        return (_openBlock(), _createElementBlock("input", {
          key: index,
          type: "hidden",
          name: "id[]",
          value: item.id
        }, null, 8, _hoisted_39))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.selectedAccessories, (accessory, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
          _createElementVNode("input", {
            type: "hidden",
            name: "id[]",
            value: accessory.variants[0].id
          }, null, 8, _hoisted_40),
          _createElementVNode("input", {
            type: "hidden",
            name: "properties[_KitOptionalProductStandardPrice]",
            value: accessory.price
          }, null, 8, _hoisted_41)
        ], 64))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.kitItems, (item, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
          _cache[2] || (_cache[2] = _createElementVNode("input", {
            type: "hidden",
            name: "properties[_KitItemType]",
            value: "item"
          }, null, -1)),
          _createElementVNode("input", {
            type: "hidden",
            name: "properties[_KitUniqueKey]",
            value: index
          }, null, 8, _hoisted_42),
          _createElementVNode("input", {
            type: "hidden",
            name: "properties[_KitItemPrice]",
            value: $options.formatPrice(item.price)
          }, null, 8, _hoisted_43),
          ($options.currentVariant.allocated_item_cost > 0)
            ? (_openBlock(), _createElementBlock("input", {
                key: 0,
                type: "hidden",
                name: "properties[_KitAllocatedCost]",
                value: $options.formatPrice($options.currentVariant.allocated_item_cost * 100)
              }, null, 8, _hoisted_44))
            : _createCommentVNode("", true)
        ], 64))
      }), 128)),
      _createElementVNode("input", {
        type: "hidden",
        name: "properties[_KitKey]",
        value: $data.kitKey
      }, null, 8, _hoisted_45),
      _createElementVNode("input", {
        type: "hidden",
        name: "properties[_KitSize]",
        value: [$options.currentVariant, ...$options.kitItems].length
      }, null, 8, _hoisted_46),
      _createElementVNode("input", {
        type: "hidden",
        name: `properties[${$data.locale.line_item_part_of}]`,
        value: $options.currentVariant.name
      }, null, 8, _hoisted_47),
      ($options.compareAtPrice > $options.price)
        ? (_openBlock(), _createElementBlock("input", {
            key: 1,
            type: "hidden",
            name: "properties[_KitCompareAtPrice]",
            value: $options.compareAtPrice
          }, null, 8, _hoisted_48))
        : _createCommentVNode("", true)
    ], 544),
    _createElementVNode("div", _hoisted_49, [
      ($options.deliverableAt)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("span", {
              class: "aspect-square w-8 rounded-full",
              style: _normalizeStyle(`background: ${$props.stockIndicator.color_overwrite}`)
            }, null, 4),
            _createElementVNode("p", null, _toDisplayString($data.locale.deliverable_at) + " " + _toDisplayString($options.deliverableAt), 1)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("span", {
              class: "aspect-square w-8 rounded-full",
              style: _normalizeStyle(`background: ${$props.stockIndicator.color}`)
            }, null, 4),
            _createElementVNode("p", null, _toDisplayString($props.stockIndicator.text), 1)
          ], 64))
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}